import React from 'react';
import { Star, ChevronRight } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { REVIEW_RATING, REVIEW_COUNT } from '../constants';
import { trackEvent } from '../analytics';
import { getScrollBehavior } from '../lib/motion';

// Review badge — five small gold stars + "{REVIEW_RATING} from
// {REVIEW_COUNT} Google reviews" + chevron, all from constants so the
// sitewide displays agree with the manually verified snapshot (not live sync).
// Rendered in the Hero (above the proof strip) and the Header (≥1100px,
// right of CONSTRUCTION). No Google logo / "G" mark anywhere.
// GA4-only event: hero_reviews_click — deliberately NOT added to the
// Meta mapping table (analytics.js stays untouched).
const ReviewBadge = ({ variant = 'hero' }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e) => {
    trackEvent('hero_reviews_click', { location: variant });
    e.preventDefault();
    // #reviews only exists on Home — from any other route, navigate Home
    // first, then smooth-scroll once the section has mounted.
    if (location.pathname === '/') {
      const el = document.getElementById('reviews');
      if (el) el.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
      return;
    }
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('reviews');
      if (el) el.scrollIntoView({ behavior: getScrollBehavior(), block: 'start' });
    }, 220);
  };

  return (
    <a
      href="/#reviews"
      className={`review-badge review-badge--${variant}`}
      data-testid={`review-badge-${variant}`}
      onClick={handleClick}
    >
      <span className="review-badge-stars" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={14} strokeWidth={0} fill="currentColor" />
        ))}
      </span>
      <span className="review-badge-text">
        {`${REVIEW_RATING} from ${REVIEW_COUNT} Google reviews`}
      </span>
      <ChevronRight size={14} strokeWidth={2.4} aria-hidden="true" className="review-badge-chevron" />
    </a>
  );
};

export default ReviewBadge;
